import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Error from "views/error";
import Home from "views/home";
import en from "locales/en";
import uz from "locales/uz";
import ru from "locales/ru";
import VerificationHome from "views/verificationContainer";
import FailPage from "views/failPage";
import PaymentPrint from "views/paymentPrint";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: en,
      },
      uz: {
        translation: uz,
      },
      ru: {
        translation: ru,
      },
    },
    lng: "uz", // if you're using a language detector, do not define the lng option
    fallbackLng: "uz",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

function App() {
  return (
    <div className="App">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/verification/:id" element={<VerificationHome />} />
          <Route path="/doc-verification/:id" element={<PaymentPrint />} />
          <Route path="/fail" element={<FailPage />} />
          <Route path="/error" element={<Error />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
